const TAG_MANAGER_ARGS: { gtmId: string } = {
  gtmId: process.env.REACT_APP_ENV === "production" ? "GTM-MPNXF52" : "GTM-M2GN7HC",
};

export default TAG_MANAGER_ARGS;
